import Vue from 'vue'
import App from './App.vue'
import vco from "v-click-outside"
Vue.use(vco);

Vue.config.productionTip = false
window.axios = require('axios');
let app = document.createElement('div');
document.body.appendChild(app)

new Vue({
  render: h => h(App),
}).$mount(app)



